let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("egLcy")).then(() => parcelRequire('mWC3n'));